import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Don't 'import mapboxgl from "mapbox-gl"' as the current version of
// mapbox-gl javascript bundle is incompatible with this version of webpack
// Instead, load the js in the view in content_for :head_js

var map = null

export default class extends Controller {
  connect() {
    this.initMapbox()
  }
  
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  
  async waitUntilDefined(variableName, checkInterval = 100) {
    while (typeof window[variableName] === 'undefined') {
      await this.sleep(checkInterval);
    }
    return window[variableName]; // Return the defined variable
  }
  
  async initMapbox() {  
    const mapElement = document.getElementById('map')
    const lat = mapElement.dataset.mapLat
    const lon = mapElement.dataset.mapLon

    if (mapElement) {
      // Wait for 'mapboxgl' to be defined
      await this.waitUntilDefined('mapboxgl');

      mapboxgl.accessToken = mapElement.dataset.mapboxApiKey
      map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/light-v9',
        zoom: 12,
        center: [lon, lat]
      })

      map.on('load', () => {
        map.loadImage('/images/map_marker.png', function(error, image) {
          if (error) {
            throw error;
          }

          if (!map.hasImage('custom-marker')) {
            map.addImage('custom-marker', image);
          }

          if (!map.getSource('dealers')) {
            map.addSource('dealers', {
              type: 'geojson',
              data: '/api/map_markers'
            });
          }

          if (!map.getLayer('dealers_layer')) {
            map.addLayer({
              id: 'dealers_layer',
              type: 'symbol',
              source: 'dealers',
              layout: {
                'icon-image': 'custom-marker',
                'icon-allow-overlap': true
              }
            });
          }
        });
      });

      map.on('click', 'dealers_layer', function(e) {
        var coordinates, description;
        coordinates = e.features[0].geometry.coordinates.slice();
        description = e.features[0].properties.description;
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }
        (new mapboxgl.Popup).setLngLat(coordinates).setHTML(description).addTo(map);
      });

      map.on('mouseenter', 'dealers_layer', function() {
        map.getCanvas().style.cursor = 'pointer';
      });
  
      map.on('mouseleave', 'dealers_layer', function() {
        map.getCanvas().style.cursor = '';
      });
    }
  }

  moveMap(event) {
    const addressElement = document.getElementById('address');
    const specialtySelector = document.querySelector('input[name="specialty"]:checked');
    const specialty = specialtySelector ? specialtySelector.value : 0;

    event.preventDefault();

    if (addressElement) {
      fetch('/api/locations/' + encodeURI(addressElement.value))
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          map.flyTo({
            center: [data.lon, data.lat],
            zoom: 12
          });

          let params = new URLSearchParams()
          params.append("lon", data.lon) 
          params.append("lat", data.lat)

          get(`/dealer_locations/${specialty}?${params}`, {
            responseKind: "turbo-stream"
          })
        })
        .catch(error => {
          console.error("Error fetching JSON:", error);
        });
    }
  };

  changeSpecialty(event) {
    const center = map.getCenter();

    let params = new URLSearchParams()
    params.append("lon", center.lng) 
    params.append("lat", center.lat)

    get(`/dealer_locations/${event.params.specialty}?${params}`, {
      responseKind: "turbo-stream"
    })

    const url = '/api/map_markers/' + event.params.specialty;
    return map.getSource('dealers').setData(url);
  }
}
